module.exports = __webpack_public_path__ + "static/media/plan-item-icon.9222eafd.svg";